import type { MutableRefObject } from 'react';
import { useEffect, useRef } from 'react';
import { CommandManager } from './CommandManager';
import type { ActionLogSender } from '@framework/action-log';
import type { ViewModelId } from 'balus-common';

export const useCommandManagerRef = (
  viewModelId: ViewModelId,
  actionLogSender?: ActionLogSender
): MutableRefObject<CommandManager> => {
  const commandManagerRef = useRef<CommandManager>(new CommandManager(viewModelId, actionLogSender));

  useEffect(() => {
    if (actionLogSender) {
      commandManagerRef.current.setActionLogSender(actionLogSender);
    }
  }, [actionLogSender]);

  return commandManagerRef;
};
